import { render, staticRenderFns } from "./BboxAndClassification.vue?vue&type=template&id=7d7f467e&scoped=true&"
import script from "./BboxAndClassification.vue?vue&type=script&lang=js&"
export * from "./BboxAndClassification.vue?vue&type=script&lang=js&"
import style0 from "./BboxAndClassification.vue?vue&type=style&index=0&id=7d7f467e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f467e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDialog,VFlex,VLayout})
